import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import ApprovalTemplate from '../../components/common/approval/ApprovalTemplate';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import { unloadTech } from '../../modules/techModule/tech';
import { unloadMidTechs } from '../../modules/techModule/techMids';
import { unloadTechPlan } from '../../modules/techModule/techPlan';
import { unloadTechRslt } from '../../modules/techModule/techRslt';
import { viewApproval } from '../../modules/userModule/approval';
import ApprovalOrderViewContainer from '../approvalmng/ApprovalOrderViewContainer';
import ApprovalTechViewContainer from '../approvalmng/ApprovalTechViewContainer';
import ApprovalTaxViewContainer from '../approvalmng/ApprovalTaxViewContainer';

const ApprovalMonitorViewContainer = () => {
  //docuCd : 세금 -> trjUuid, 수주-> roUuid, 기술:techUuid
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [titleData, setTitleData] = useState(null);

  const { approval, error, loading } = useSelector(
    ({ userModule, loading }) => ({
      approval: userModule.approval.approval,
      error: userModule.approval.error,
      loading: loading['user/VIEW_APPROVAL'],
    }),
  );

  useEffect(() => {
    dispatch(viewApproval(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (approval) {
      const name = approval.docyTyp + ' [' + approval.docuNo + ']';
      setTitleData({ name: name });
    }
  }, [approval]);

  const handleGoBack = () => {
    dispatch(unloadTech());
    dispatch(unloadTechPlan());
    dispatch(unloadMidTechs());
    dispatch(unloadTechRslt());
    navigate('/approvalmng/monitoring');
  };

  return (
    <ApprovalTemplate approval={approval} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="결재관리/결재 모니터링/결재 상세"
        menuLink="/approvalmng/monitoring"
        icon="approval"
        titleData={titleData}
      />
      {approval && approval.docyTyp === '수주' && (
        <ApprovalOrderViewContainer id={approval?.docuCd} />
      )}
      {approval && approval.docyTyp === '기술' && (
        <ApprovalTechViewContainer id={approval?.docuCd} />
      )}
      {approval && approval.docyTyp === '세금' && (
        <ApprovalTaxViewContainer id={approval?.docuCd} />
      )}
    </ApprovalTemplate>
  );
};

export default ApprovalMonitorViewContainer;
